import axios from 'axios';
import { ENDPOINTS } from '../constants';
import { IUser } from '../types/IUser';
import { EWithdrawStatus } from '../types/EWithdrawStatus';

export const getMyProfile = async () => {
    const res = await axios.get(`${axios.defaults.baseURL}${ENDPOINTS.myProfile}`);
    return res.data;
};

export const getUserAvatar = async (id: string) => {
    const res = await axios.get(`${axios.defaults.baseURL}${ENDPOINTS.userAvatar}/${id}`);
    return res.data;
};

export interface IGetUserParams {
    id: string;
}

export const getUser = async ({ id }: IGetUserParams): Promise<IUser> => {
    const res = await axios.get(`${axios.defaults.baseURL}${ENDPOINTS.getUser}/${id}`);

    return res.data;
};

export interface IRecentGame {
    challengeId: string;
    finishedAt: string;
    game: string;
    gameVersion: string;
    mode: string | null;
    isTournament: boolean;
    result: 'Win' | 'Loss' | 'Draw';
    amount: number;
    bet: number;
    opponentNickName: string | null;
}

export interface IRecentGames {
    totalGames: number;
    games: IRecentGame[];
}

export const getUserRecentGames = async (userId: string, limit = 10): Promise<IRecentGames> => {
    const res = await axios.get(
        `${axios.defaults.baseURL}${ENDPOINTS.getUserRecentGames.replace(':userId', userId)}`,
        { params: { limit } }
    );

    return res.data;
};
